import { useRef, useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import SectionTitle from '../SectionTitle/SectionTitle'
import 'swiper/css'
import 'swiper/css/navigation'

import styles from './ReviewsSection.module.scss'

const API_PREFIX = process.env.REACT_APP_API_URL || 'http://localhost:8000';

function StarRating({ count }) {
	return (
		<div className={styles.starRating}>
			{Array.from({ length: 5 }).map((_, i) => (
				<span
					key={i}
					className={`${styles.star} ${i < count ? styles.filled : ''}`}
				>
					★
				</span>
			))}
		</div>
	)
}

export default function ReviewsSection() {
	const swiperRef = useRef(null)
	const prevRef = useRef(null)
	const nextRef = useRef(null)

	const [reviews, setReviews] = useState([])
	const [loading, setLoading] = useState(true)
	const [error, setError] = useState(null)

	useEffect(() => {
		fetch(`${API_PREFIX}/api/sections/get/reviews/list`)
			.then((res) => {
				if (!res.ok) throw new Error('Ошибка загрузки отзывов')
				return res.json()
			})
			.then((data) => {
				setReviews(data.reviews ?? [])
				setLoading(false)
			})
			.catch((e) => {
				setError(e.message)
				setLoading(false)
			})
	}, [])

	const isTouchDevice = () =>
		'ontouchstart' in window || navigator.maxTouchPoints > 0

	const handleButtonEffect = (e) => {
		if (!e.currentTarget) return
		e.currentTarget.classList.add(styles.active)
		setTimeout(() => {
			if (e.currentTarget) {
				e.currentTarget.classList.remove(styles.active)
			}
		}, 300)
	}

	useEffect(() => {
		if (swiperRef.current && swiperRef.current.swiper) {
			const swiper = swiperRef.current.swiper
			swiper.params.navigation.prevEl = prevRef.current
			swiper.params.navigation.nextEl = nextRef.current
			swiper.navigation.destroy()
			swiper.navigation.init()
			swiper.navigation.update()
		}
	}, [reviews])

	return (
		<section className={styles.reviews}>
			<div className={styles.reviewsContainer}>
				<SectionTitle>Отзывы наших учеников</SectionTitle>

				{loading && <div>Загрузка...</div>}
				{error && <div style={{ color: 'red' }}>Ошибка: {error}</div>}

				{!loading && !error && (
					<Swiper
						ref={swiperRef}
						modules={[Navigation]}
						spaceBetween={30}
						grabCursor={true}
						loop={true}
						slidesPerView={3}
						navigation={{
							prevEl: prevRef.current,
							nextEl: nextRef.current,
						}}
						breakpoints={{
							320: { slidesPerView: 1, spaceBetween: 20 },
							740: { slidesPerView: 2, spaceBetween: 25 },
							1040: { slidesPerView: 3, spaceBetween: 30 },
						}}
						onSwiper={(swiper) => {
							swiper.params.navigation.prevEl = prevRef.current
							swiper.params.navigation.nextEl = nextRef.current
							swiper.navigation.init()
							swiper.navigation.update()
						}}
					>
						{reviews.map(({ id, name, rating, text, avatar }) => (
							<SwiperSlide key={id}>
								<div
									className={`${styles.reviewCard} ${
										id % 2 === 0
											? styles.reviewCardLight
											: styles.reviewCardGreen
									}`}
								>
									<div className={styles.reviewHeader}>
										<h3 className={styles.reviewName}>{name}</h3>
										{/* Если есть аватар: */}
										{/* <div className={styles.reviewAvatar}>
                      {avatar ? (
                        <img src={
                            avatar.startsWith('/') ? API_PREFIX + avatar : avatar
                          }
                          alt={name}
                          loading='lazy'
                        />
                      ) : (
                        <div className={styles.avatarPlaceholder} />
                      )}
                    </div> */}
									</div>
									<StarRating count={rating} />
									<p className={styles.reviewText}>{text}</p>
								</div>
							</SwiperSlide>
						))}
					</Swiper>
				)}

				<div className={styles.reviewsNavigation}>
					<div
						className={styles.reviewsSliderButtonPrev}
						ref={prevRef}
						onClick={() => swiperRef.current?.swiper.slidePrev()}
					>
						<div
							className={styles.btnContainer}
							{...(isTouchDevice()
								? { onTouchStart: handleButtonEffect }
								: { onMouseDown: handleButtonEffect })}
						>
							<div className={styles.consultBtn}>
								<img src='/img/slider/arrow-left.svg' alt='Prev' />
							</div>
						</div>
					</div>

					<div
						className={styles.reviewsSliderButtonNext}
						ref={nextRef}
						onClick={() => swiperRef.current?.swiper.slideNext()}
					>
						<div
							className={styles.btnContainer}
							{...(isTouchDevice()
								? { onTouchStart: handleButtonEffect }
								: { onMouseDown: handleButtonEffect })}
						>
							<div className={styles.consultBtn}>
								<img src='/img/slider/arrow-right.svg' alt='Next' />
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	)
}
